import { createContext, useContext, useEffect, useState } from "react";
import { createCart, loadCart, saveCart } from "@/lib/cart";
import { trackAddToCart } from "@/lib/analytics";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState(() => loadCart() || createCart());

    useEffect(() => {
        saveCart(cart);
    }, [cart]);

    const addItem = (item) => {
        setCart((c) => {
            const idx = c.items.findIndex(
                (i) =>
                    i.product_slug === item.product_slug &&
                    i.color === item.color &&
                    i.side === item.side
            );
            const items = [...c.items];
            if (idx >= 0) items[idx] = { ...items[idx], qty: items[idx].qty + (item.qty || 1) };
            else items.push({ ...item, qty: item.qty || 1 });
            return { ...c, items };
        });
        try { trackAddToCart({ item: { ...item, qty: item.qty || 1 } }); } catch (e) { /* analytics never breaks app */ }
    };

    const removeItem = (index) => {
        setCart((c) => ({ ...c, items: c.items.filter((_, i) => i !== index) }));
    };

    const updateQty = (index, qty) => {
        setCart((c) => {
            const items = [...c.items];
            items[index] = { ...items[index], qty: Math.max(1, qty) };
            return { ...c, items };
        });
    };

    const clear = () => setCart(createCart());

    const subtotal = cart.items.reduce((s, i) => s + i.price * i.qty, 0);
    const count = cart.items.reduce((s, i) => s + i.qty, 0);

    return (
        <CartContext.Provider
            value={{ cart, addItem, removeItem, updateQty, clear, subtotal, count }}
        >
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => {
    const ctx = useContext(CartContext);
    if (!ctx) throw new Error("useCart must be inside CartProvider");
    return ctx;
};
